import api from '@/lib/axios';

export const comprasService = {
  async findAll(params: {
    companyId: string; branchId?: string; supplierId?: string;
    status?: string; search?: string; page?: number; limit?: number;
  }) {
    const response = await api.get('/purchases', { params });
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/purchases/${id}`);
    return response.data;
  },

  async create(data: {
    companyId: string; branchId: string; supplierId: string;
    notes?: string;
    grandTotal?: number;
    userId?: string;
    createdById?: string;
    items: Array<{ productId: string; quantity: number; unitPrice: number; subtotal?: number }>;
  }) {
    const response = await api.post('/purchases', data);
    return response.data;
  },

  async submit(id: string) {
    const response = await api.patch(`/purchases/${id}/submit`);
    return response.data;
  },

  async approve(id: string) {
    const response = await api.patch(`/purchases/${id}/approve`);
    return response.data;
  },

  async receive(id: string) {
    const response = await api.patch(`/purchases/${id}/receive`);
    return response.data;
  },

  async cancel(id: string, reason: string) {
    const response = await api.patch(`/purchases/${id}/cancel`, { reason });
    return response.data;
  },
};
